export const clickCheckbox = (distributionId, checkSelected) => {
  const selectedIndex = checkSelected.indexOf(distributionId);
  let newSelected = [];
  if (selectedIndex === -1) {
    newSelected = newSelected.concat(checkSelected, distributionId);
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(checkSelected.slice(1));
  } else if (selectedIndex === checkSelected.length - 1) {
    newSelected = newSelected.concat(checkSelected.slice(0, -1));
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(
      checkSelected.slice(0, selectedIndex),
      checkSelected.slice(selectedIndex + 1)
    );
  }
  return newSelected;
};

export const clickCheckboxInSells = (distributionId, checkSelected) => {
  const selectedIndex = checkSelected.indexOf(distributionId);
  let newSelected = [];
  if (selectedIndex === -1) {
    newSelected = newSelected.concat(checkSelected, distributionId);
  } else if (selectedIndex === 0) {
    newSelected = newSelected.concat(checkSelected.slice(1));
  } else if (selectedIndex === checkSelected.length - 1) {
    newSelected = newSelected.concat(checkSelected.slice(0, -1));
  } else if (selectedIndex > 0) {
    newSelected = newSelected.concat(
      checkSelected.slice(0, selectedIndex),
      checkSelected.slice(selectedIndex + 1)
    );
  }
  return newSelected;
};

export const selectAllCheckbox = (event, state, product) => {
  if (event.target.checked) {
    const newSelected = [];
    state.forEach((n) => {
      switch (product) {
        case "movile":
          newSelected.push(n.movileId);
          break;
        case "accesory":
          newSelected.push(n.accesoryId);
          break;
        case "chip":
          newSelected.push(n.chipId);
          break;
        case "product":
          if (n.statusDistributionId === 2) {
            console.log("statusDistributionId 2 selected");
            // return;
          } else newSelected.push(n.id);
          break;
        case "cash_card":
          newSelected.push(n.cashCardId);
          break;
        default:
          break;
      }
    });
    console.log("newSelected", newSelected);
    return newSelected;
  }
  return [];
};

export const selectAllCheckboxInSells = (event, sellsArray) => {
  const newSelected = [];
  if (event.target.checked) {
    sellsArray.forEach((n) => {
      if (!n.product.factureCreated) {
        newSelected.push(n.id);
      }
    });
    return newSelected;
  }
  return [];
};

export const selectAllCheckBoxDistributions = (event, distributionArray) => {
  const optionsSelected = [];
  if (event.target.checked) {
    distributionArray.forEach((element) => {
      if (
        element.statusDistributionId !== 2 &&
        element.statusDistributionId !== 4
      ) {
        optionsSelected.push(element.id);
      }
    });
    return optionsSelected;
  }
  return [];
};
